import API from '../helpers/api';
import {TUser} from "../helpers/types";

export const authUser = (authData: {username: string, password: string}) => API.post('/auth', authData).then((response:any) => response.data)
export const getAllUsers = () => API.get('/users').then((response:any): TUser[] => response.data.data);
export const getUserById = (id: string) => API.get(`/users/${id}`).then((response:any): TUser => response.data)
export const updateUser = (id: string, updatedData: TUser) => API.put(`/users/${id}`, updatedData).then((response:any): TUser => response.data)
